/** Retry only a confirmed image-content refusal, never an uncertain generation failure. */
export function isContentModerationError(error: unknown): boolean {
    if (!(error instanceof Error)) return false;
    const code = 'code' in error && typeof error.code === 'string' ? error.code.toLowerCase() : '';
    if (code) return ['moderation_blocked', 'content_policy_violation', 'safety_checker', 'content_filtered', 'image_safety'].includes(code);
    return /moderation|content policy|content filter|safety|inappropriate/i.test(error.message);
}
